// extracted by mini-css-extract-plugin
module.exports = {"button":"StaticMapButton_button__2uuwG","expand":"StaticMapButton_expand__82WE1"};